module.exports = __webpack_public_path__ + "static/media/jumbotron_bg.4e656904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/main/jumbotron_bg.jpg
// module id = 974
// module chunks = 124